import React from 'react';
import { Link } from 'react-router-dom';
// import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faCalendar, faCheckCircle, faHome, faIdCard, faLayerGroup, faListAlt, faListCheck, faListDots, faListOl, faQrcode, faUser, faUsers, faUserTie } from '@fortawesome/free-solid-svg-icons';
// import './ThinkService.css';
// import thinkserviceimage from '../../assets/pageimages/ThinkService.webp';

function ThinkServiceHome() {
  const services = [
    { title: '2 Wheelers', category: 'Bicycle', icon: 'fa-bicycle' }, 
    { title: '4 Wheelers', category: 'Car', icon: 'fa-car' }, 
    { title: 'AC', category: 'AC', icon: 'fa-wind' }, 
    { title: 'Arts Teacher', category: 'Arts Teacher', icon: 'fa-palette' },
    { title: 'Baby Sitter', category: 'Baby Sitter', icon: 'fa-baby' },
    { title: 'Birthday & Party Organizers', category: 'Birthday & Party Organizers', icon: 'fa-birthday-cake' },

    { title: 'CCTV', category: 'CCTV', icon: 'fa-video' }, 
    { title: 'Chef', category: 'Chef', icon: 'fa-utensils' },

    { title: 'Computer & Laptop', category: 'Computer', icon: 'fa-laptop' }, 
    { title: 'Decorators', category: 'Decorators', icon: 'fa-paint-roller' },
    { title: 'Driver', category: 'Driver', icon: 'fa-taxi' },

    { title: 'Drone Inspection', category: 'Drone Inspection', icon: 'fa-plane' }, 
    { title: 'Electrical', category: 'Electrical Equipment', icon: 'fa-bolt' }, 
    { title: 'Fitness & Yoga', category: 'Fitness', icon: 'fa-dumbbell' }, 
    { title: 'Home Appliance', category: 'Home Appliance', icon: 'fa-tv' }, 
    { title: 'Home Delivery', category: 'Home Delivery', icon: 'fa-truck' }, 
    // { title: 'Housekeeper', category: 'Housekeeper', icon: 'fa-broom' },
    { title: 'Industrial Machines', category: 'Machines', icon: 'fa-cogs' }, 
    { title: 'Interior Designers', category: 'Interior Designers', icon: 'fa-couch' }, 
    // { title: 'Job Workers', category: 'Job Workers', icon: 'fa-user-cog' },

    { title: 'Key Makers', category: 'Key Makers', icon: 'fa-key' }, 
    { title: 'Mobile & Tablet', category: 'Mobile', icon: 'fa-mobile-alt' }, 
    { title: 'Medical Equipment', category: 'Medical Equipment', icon: 'fa-stethoscope' }, 
    { title: 'Movers & Packers', category: 'Movers & Packers', icon: 'fa-truck-monster' },
    { title: 'Music Teacher', category: 'Music Teacher', icon: 'fa-music' },
    { title: 'Porter', category: 'Porter', icon: 'fa-dolly' }, 
    { title: 'Pandit', category: 'Pandit', icon: 'fa-praying-hands' }, 
    { title: 'Plumber', category: 'Plumber', icon: 'fa-wrench' }, 
    { title: 'Printer', category: 'Printer', icon: 'fa-print' }, 
    { title: 'QC', category: 'QC', icon: 'fa-clipboard-check' }, 
    { title: 'Real Estate', category: 'Real Estate', icon: 'fa-building' }, 
    { title: 'Robots', category: 'Robots', icon: 'fa-robot' }, 
    { title: 'RTO Services', category: 'RTO Services', icon: 'fa-road' }, 
    { title: 'Sports Coach', category: 'Sports Coach', icon: 'fa-futbol' },
    { title: 'Subject Teacher', category: 'Subject Teacher', icon: 'fa-chalkboard-teacher' },
    { title: 'Tution', category: 'Tution', icon: 'fa-chalkboard-teacher' }, 
    { title: 'TV', category: 'TV', icon: 'fa-tv' }, 
    { title: 'Unlisted', category: 'Unlisted', icon: 'fa-question-circle' }
  ]

  return (
    <div className='bg-black'>
      <div className="min-h-screen py-2 bg-black">
        <div className="flex flex-col p-2 border-b border-blue-400">
          <h2 className='text-lg lg:text-2xl font-bold text-yellow-200 text-center mb-2'>🏢 ThinkService</h2>
          <p className='text-center text-white text-sm lg:text-lg'>Transforming Service With AI</p>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-6 gap-2 place-items-center bg-black border-b border-blue-400 mb-2 p-2 rounded-lg shadow-lg items-center mt-2">
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faHome} className="text-lg lg:text-xl mr-3" />
            <span>My Account</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faCalendar} className="text-lg lg:text-xl mr-3" />
            <span>Book A Serivce</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faBolt} className="text-lg lg:text-xl mr-3" />
            <span>I Need Emergency Service</span>
          </Link>
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faCalendar} className="text-lg lg:text-xl mr-3" />
            <span>Skill & Training</span>
          </Link>
          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faUserTie} className="text-lg lg:text-xl mr-3" />
            <span>Service Provider</span>
          </Link>

          <Link to={""} className="flex items-center text-sm lg:text-md text-gray-100 hover:text-gray-200transition duration-300">
            <FontAwesomeIcon icon={faLayerGroup} className="text-lg lg:text-xl mr-3" />
            <span>Digital Boutique</span>
          </Link>
        </div>
        <div className="grid grid-cols-3 lg:grid-cols-8 gap-2">
          {services.map((service, index) => (
            <Link
              key={index}
              to={`/think-service-services-list/${service.category}`}
              className="block"
            >
              <div
                className="
                  flex flex-col items-center justify-center
                  h-20 lg:h-24 
                  w-full
                  bg-gray-800
                  border border-gray-700
                  rounded-xl
                  text-center
                  transition
                  hover:bg-cyan-600 hover:text-black
                  active:scale-95
                "
              >
                <i
                  className={`fas ${service.icon} text-2xl mb-2 text-blue-400`}
                ></i>

                <h2 className="text-xs lg:text-sm font-medium px-2 leading-tight line-clamp-2 text-white">
                  {service.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>
      </div>
      <footer className="bg-black text-white py-2 px-4 border-t border-blue-400">
        <div className="flex flex-col lg:flex-row justify-between items-center text-center lg:text-left">
          <p className="text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex space-x-6 mt-4 lg:mt-0 text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-400 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-400 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-400 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-400 transition">Contact</Link>
          </div>
        </div>
      </footer>      
    </div>
  );
}

export default ThinkServiceHome;



